export default "__VITE_ASSET__dadcdb81__"